import { render } from "./dependents-radio-list.vue?vue&type=template&id=1c4ea16a&scoped=true"
import script from "./dependents-radio-list.vue?vue&type=script&lang=js"
export * from "./dependents-radio-list.vue?vue&type=script&lang=js"

import "./dependents-radio-list.vue?vue&type=style&index=0&id=1c4ea16a&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4ea16a"]])

export default __exports__